<template>
    <BrandTable :userId="userId" :token="token" />
</template>

<script>
import BrandTable from './BrandTable.vue'

export default {
    props: {
        userId: {
            type: [Number, String, null],
            required: false,
            default: null,
        },
        token: {
            type: String,
            default: '',
        },
    },
    components: {
        BrandTable,
    },
}
</script>
